function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import Observer from '@researchgate/react-intersection-observer';
import { propsWithNoScriptRender } from '../lib/wrap';

var Lazy = function (_React$PureComponent) {
  _inherits(Lazy, _React$PureComponent);

  function Lazy(props) {
    _classCallCheck(this, Lazy);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

    _this.state = {
      show: false
    };
    _this.handleViewport = _this.handleViewport.bind(_this);
    return _this;
  }

  Lazy.prototype.handleViewport = function handleViewport(event, unobserve) {
    if (!event.isIntersecting || !this.props.visible) {
      return;
    }

    if (this.props.onViewport) {
      this.props.onViewport(event);
    }

    if (event.defaultPrevented) {
      return;
    }

    unobserve();
    this.setState({
      show: true
    }, this.props.onLoad);
  };

  Lazy.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        clientOnly = _props.clientOnly,
        component = _props.component,
        cushion = _props.cushion,
        ref = _props.forwardedRef,
        ltIE9 = _props.ltIE9,
        visible = _props.visible,
        onLoad = _props.onLoad,
        onViewport = _props.onViewport,
        threshold = _props.threshold,
        viewport = _props.viewport,
        rest = _objectWithoutProperties(_props, ['children', 'clientOnly', 'component', 'cushion', 'forwardedRef', 'ltIE9', 'visible', 'onLoad', 'onViewport', 'threshold', 'viewport']);

    var props = Object.assign({
      ref: ref
    }, rest);
    var isClientRender = clientOnly || this.state.show;
    return React.createElement(Observer, {
      onChange: this.handleViewport,
      root: viewport,
      rootMargin: cushion,
      threshold: threshold
    }, React.createElement(component, isClientRender ? props : propsWithNoScriptRender(children, ltIE9, props), isClientRender && this.state.show && visible ? children : null));
  };

  return Lazy;
}(React.PureComponent);

Lazy.defaultProps = {
  clientOnly: false,
  component: 'div',
  ltIE9: false,
  visible: true
};
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default React.forwardRef(function (props, ref) {
  return React.createElement(Lazy, Object.assign({}, props, {
    forwardedRef: ref
  }));
});